/*
 * Layout  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FunctionComponent } from "react";
import { LayoutState_Row } from "./LayoutState";
import { TLayoutActivateHandler, TLayoutRenderComponentFn } from "./LayoutTypes";
import { LayoutContainer } from "./LayoutContainer";

export interface ILayoutRowProps {
	state: LayoutState_Row;
	renderComponent: TLayoutRenderComponentFn;
	onActivate?: TLayoutActivateHandler;
}

export const LayoutRow: FunctionComponent<ILayoutRowProps> = ({ state, renderComponent, onActivate }) => {
	return <LayoutContainer state={state} renderComponent={renderComponent} onActivate={onActivate} />;
};
